import Vue from 'vue'
import VueI18n from 'vue-i18n'

import { dateTimeFormats } from '@/locale/dateFormat/format'
import { messages } from '../locale/language/index'

// Taken from https://github.com/kazupon/vue-i18n/issues/184#issuecomment-545954961
export const VueI18nWrapper = {
  install(Vue) {
    const _$t = Vue.prototype.$t

    if (!_$t) {
      throw new Error('vue-i18n plugin should be installed first')
    }

    Vue.prototype.$t = function(...args) {
      if (this.$i18n) {
        return _$t.apply(this, args)
      } else {
        return _$t.apply(this.$root, args)
      }
    }
  }
}

Vue.use(VueI18n)
Vue.use(VueI18nWrapper)

const fallbackLocale = 'en'

function findCurrentLanguage(language) {
  if (Object.keys(messages).includes(language)) {
    return language
  }
  return fallbackLocale
}

export const i18n = new VueI18n({
  locale: findCurrentLanguage(navigator.language.split('-').shift()), // fetch and set browser language
  fallbackLocale, // set fallback locale
  messages, // set locale messages,
  dateTimeFormats, // set locale date format
  silentFallbackWarn: true // shut up i18n in dev mode
})

export const getI18n = locale => {
  Vue.use(VueI18n)
  Vue.use(VueI18nWrapper)
  return new VueI18n({
    locale: findCurrentLanguage(locale), // fetch and set browser language
    fallbackLocale, // set fallback locale
    messages, // set locale messages,
    dateTimeFormats, // set locale date format
    silentFallbackWarn: true // shut up i18n in dev mode
  })
}
